<div class="mx-5">
  <header class="sticky-top bg-white py-3 border-bottom">
    <h1 class="h2 mb-1">{{ "navigationReleaseFeatures" | localize }}</h1>
  </header>

  <table class="table">
    <tbody>
      <tr *ngFor="let feature of features">
        <td [attr.data-testid]="'feature-name-' + feature.name">{{ feature.name }}</td>
        <td [attr.data-testid]="'feature-status-' + feature.name">
          {{ (feature.released ? "releaseFeaturesReleasedLabel" : "releaseFeaturesNotReleasedLabel") | localize }}
        </td>
        <td>
          <action-button
            *ngIf="!feature.released"
            buttonType="button"
            buttonLabel="releaseFeaturesReleaseButtonLabel"
            [testId]="'feature-release-' + feature.name"
            (buttonClick)="releaseFeature(feature.name)"
          ></action-button>
        </td>
      </tr>
    </tbody>
  </table>
</div>
